import { useRedirect, useTranslate } from 'react-admin';

export const ItemCategorySettingsButton = () => {

  const translate = useTranslate();
  const redirect = useRedirect();

  return (
    <button type="button" className="sidebar-item-category-settings-button" onClick={() => {

      redirect('list', 'security-inventory-categories');

    }}>
      <span>{translate('resources.security-inventory-categories.text.settings_button')}</span>
    </button>
  );

};
